import { ModuleWithProviders, NgModule } from '@angular/core';

import { IconProvider, SocialMediaPipe } from './social-media.pipe';

@NgModule({
  imports: [SocialMediaPipe],
  exports: [SocialMediaPipe],
})
export class SocialMediaModule {
  public static withIcons(
    iconProvider: (icon: string) => Promise<string>,
  ): ModuleWithProviders<SocialMediaModule> {
    return {
      ngModule: SocialMediaModule,
      providers: [{ provide: IconProvider, useValue: iconProvider }],
    };
  }
}

export * from './social-media.pipe';
